// Colored pill indicators for violation agency and compliance status (Section C: light bg + colored text).
import { pillStyle } from '@/components/StatusDot';

const AGENCY_COLORS = {
  DOB: '#1B4A76', FDNY: '#E5441A', DOT: '#16A34A', DEP: '#D97706', ECB: '#031333', HPD: '#0891B2', Other: '#031333',
};
const STATUS_COLORS = {
  Active: '#E5441A', Resolved: '#16A34A', Dismissed: '#031333', 'Written Off': '#031333', Pending: '#D97706',
};

function Dot({ color, label, testid }) {
  if (!label) return <span className="text-sm text-muted-foreground">-</span>;
  return (
    <span className="inline-flex items-center" style={pillStyle(color)} data-testid={testid}>{label}</span>
  );
}

export function AgencyDot({ agency }) {
  return <Dot color={AGENCY_COLORS[agency]} label={agency} testid="agency-dot" />;
}

export function ViolationStatusDot({ status }) {
  return <Dot color={STATUS_COLORS[status]} label={status} testid="violation-status-dot" />;
}
